/**
 * MELANUA Preview Mode Context
 * Now live - prices always visible
 */

import React, { createContext, useContext } from 'react';

const PreviewContext = createContext(null);

export function PreviewProvider({ children }) {
    // Site is live - always show prices
    const value = {
        isPreviewMode: true,
        enablePreview: () => {}
    };

    return (
        <PreviewContext.Provider value={value}>
            {children}
        </PreviewContext.Provider>
    );
}

export function usePreview() {
    const context = useContext(PreviewContext);
    if (!context) {
        throw new Error('usePreview must be used within a PreviewProvider');
    }
    return context;
}

// Helper component to show price
export function Price({ amount, className = '' }) {
    const formatted = typeof amount === 'number'
        ? amount.toFixed(2)
        : parseFloat(amount).toFixed(2);

    return <span className={className}>${formatted}</span>;
}

export default PreviewContext;
